module.exports = __webpack_public_path__ + "media/asset/images/pdf-ed27681245a2d90d98045173fcf7ac83.png";